import React from 'react';
export function EmotionalHeroSection() {
  return <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-baby-pink-light via-baby-cream to-baby-blue-light" data-id="element-409">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-410">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center" data-id="element-411">
          {/* Image */}
          <div className="animate-fade-in-up" data-id="element-412">
            <div className="relative rounded-baby-lg overflow-hidden shadow-baby-glow" data-id="element-413">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/q8YzhfYH4H3gu8Rf1MBocm/5-mom%E2%80%99s_and_baby%E2%80%99s.png" alt="Mamá feliz con su bebé - Alimentación sin miedo ni culpa" className="w-full h-auto" data-id="element-414" />
            </div>
          </div>

          {/* Content */}
          <div className="animate-fade-in-up" style={{
          animationDelay: '0.2s'
        }} data-id="element-415">
            <div className="bg-white/90 backdrop-blur-baby p-8 sm:p-10 rounded-baby-lg border-2 border-baby-lavender shadow-baby-glow" data-id="element-416">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 bg-gradient-to-r from-baby-pink via-baby-lavender to-baby-blue bg-clip-text text-transparent" data-id="element-417">
                Alimenta a tu bebé sin miedo ni culpa
              </h2>

              <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-6" data-id="element-418">
                Con recetas probadas para el día a día
              </p>

              <div className="space-y-4" data-id="element-419">
                <div className="flex items-start gap-3 bg-baby-blue-light/50 p-4 rounded-baby" data-id="element-420">
                  <span className="text-2xl flex-shrink-0" data-id="element-421">✓</span>
                  <p className="text-sm sm:text-base text-gray-800 font-medium" data-id="element-422">
                    <strong data-id="element-423">Ingredientes claros</strong> - Todo lo que necesitas
                    está en tu cocina
                  </p>
                </div>

                <div className="flex items-start gap-3 bg-baby-pink-light/50 p-4 rounded-baby" data-id="element-424">
                  <span className="text-2xl flex-shrink-0" data-id="element-425">✓</span>
                  <p className="text-sm sm:text-base text-gray-800 font-medium" data-id="element-426">
                    <strong data-id="element-427">Pasos simples</strong> - Sin complicaciones ni
                    técnicas difíciles
                  </p>
                </div>

                <div className="flex items-start gap-3 bg-baby-blue-light/50 p-4 rounded-baby" data-id="element-428">
                  <span className="text-2xl flex-shrink-0" data-id="element-429">✓</span>
                  <p className="text-sm sm:text-base text-gray-800 font-medium" data-id="element-430">
                    <strong data-id="element-431">Texturas por edad</strong> - Sabrás exactamente qué
                    es seguro
                  </p>
                </div>
              </div>

              <div className="mt-6 pt-6 border-t-2 border-baby-lavender" data-id="element-432">
                <p className="text-lg sm:text-xl font-bold text-center text-gray-900" data-id="element-433">
                  Porque tu bebé merece comida casera, y tú mereces tranquilidad
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}